import { useHaptics } from '@/hooks/use-haptics';
import { Button } from '@mantine/core';
import { ComponentProps } from 'react';
import styles from './styles.module.css';

type StandardButtonProps<C = 'button'> = ComponentProps<typeof Button<C>>;

export const StandardButton = (props: StandardButtonProps) => {
	const onClick = useHaptics(props);

	return <Button w="100%" className={styles.root} variant="filled" {...props} onClick={onClick} />;
};
